import { render, staticRenderFns } from "./QuickInfoContent.vue?vue&type=template&id=c87d31ca&scoped=true&"
import script from "./QuickInfoContent.vue?vue&type=script&lang=js&"
export * from "./QuickInfoContent.vue?vue&type=script&lang=js&"
import style0 from "./QuickInfoContent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QuickInfoContent.vue?vue&type=style&index=1&id=c87d31ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87d31ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VRow})
